"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ArrowDownIcon = function ArrowDownIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.293 9.293a1 1 0 0 1 1.414 0l4.288 4.288 4.299-4.289a1 1 0 0 1 1.412 1.416l-4.299 4.29c-.781.78-2.044.78-2.824 0l-4.29-4.29a1 1 0 0 1 0-1.415z"
  }));
};
ArrowDownIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "header": "header_1laA1M",
  "title": "title_cz2YMj",
  "icon": "icon_Pt0_r6",
  "closed": "closed_DNRKQK",
  "content": "content_93RlsF"
}; 
require('./CollapsibleCard.css');
var CollapsibleCard = /*#__PURE__*/function (_React$Component) {
  function CollapsibleCard() {
    var _this;
    (0, _classCallCheck2.default)(this, CollapsibleCard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CollapsibleCard, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", {
      isExpanded: _this.props.isExpanded
    });
    (0, _defineProperty2.default)(_this, "toggle", function () {
      if (!_this.state.isExpanded) {
        _this.props.onOpen();
      }
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          isExpanded: !prevState.isExpanded
        });
      });
    });
    return _this;
  }
  (0, _inherits2.default)(CollapsibleCard, _React$Component);
  return (0, _createClass2.default)(CollapsibleCard, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var isExpanded = this.props.isExpanded;
      if (nextProps.isExpanded !== isExpanded) {
        this.setState({
          isExpanded: nextProps.isExpanded
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        title = _this$props.title,
        children = _this$props.children,
        className = _this$props.className,
        testId = _this$props.testId;
      var isExpanded = this.state.isExpanded;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: (0, _classnames.default)(className, styles.header),
        onClick: this.toggle,
        "data-test-id": "collapsible-card-header-".concat(testId),
        "aria-expanded": isExpanded
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        className: (0, _classnames.default)(styles.icon, (0, _defineProperty2.default)({}, styles.closed, !isExpanded)),
        size: "xs",
        "data-test-id": "collapsible-card-expandable-icon"
      }, /*#__PURE__*/_react.default.createElement(ArrowDownIcon, null)), /*#__PURE__*/_react.default.createElement("span", {
        className: styles.title,
        "data-test-id": "collapsible-card-title-".concat(testId)
      }, title)), isExpanded ? /*#__PURE__*/_react.default.createElement("div", {
        className: styles.content,
        "data-test-id": "collapsible-card-content-".concat(testId)
      }, children) : null);
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(CollapsibleCard, "defaultProps", {
  title: '',
  isExpanded: false,
  onOpen: function onOpen() {}
});
var _default = exports.default = CollapsibleCard;
//# sourceMappingURL=CollapsibleCard.js.map